import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LuvlyGuide = lazyWithPreload(() => import('./LuvlyGuide'))
